import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfServicePage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1758">
      <Header data-id="element-1759" />
      <main className="flex-grow pt-36 pb-24" data-id="element-1760">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-1761">
          <div className="mb-8" data-id="element-1762">
            <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium" data-id="element-1763">
              <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-1764" />
              Back to Home
            </Link>
          </div>
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 sm:p-10" data-id="element-1765">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 font-serif" data-id="element-1766">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1767">
                Terms of Service
              </span>
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-1768">Last Updated: August 13, 2025</p>
            <div className="prose prose-lg max-w-none text-gray-700" data-id="element-1769">
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1770">
                1. Acceptance of Terms
              </h2>
              <p data-id="element-1771">
                By accessing or using Creator Boost tools and services, you
                agree to be bound by these Terms and our Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1772">
                2. Services Overview
              </h2>
              <p data-id="element-1773">
                Creator Boost offers a range of digital tools (e.g.,
                Newsfiliate) designed for content creators. These tools are
                governed by this unified Terms of Service.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1774">
                3. User Eligibility
              </h2>
              <p data-id="element-1775">
                You must be at least 18 years old to use any Creator Boost
                service.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1776">
                4. License to Use
              </h2>
              <p data-id="element-1777">
                We grant you a limited, non-exclusive license to use our tools
                for your own purposes; commercial redistribution or copying is
                prohibited.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1778">
                5. Account Responsibilities
              </h2>
              <p data-id="element-1779">
                If an account is required, you're responsible for keeping
                credentials secure and for all activity under your account.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1780">
                6. Payments and Subscriptions
              </h2>
              <p data-id="element-1781">
                For services with paid tiers or subscriptions, the following
                terms apply:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1782">
                <li data-id="element-1783">
                  <strong data-id="element-1784">Billing Cycle:</strong> Subscriptions are billed in
                  advance on a recurring basis according to your selected plan.
                </li>
                <li data-id="element-1785">
                  <strong data-id="element-1786">Auto-Renewal:</strong> Subscriptions automatically
                  renew unless cancelled at least 24 hours before the end of the
                  current period.
                </li>
                <li data-id="element-1787">
                  <strong data-id="element-1788">Cancellation:</strong> You can cancel your
                  subscription at any time through your account settings or by
                  contacting customer support.
                </li>
                <li data-id="element-1789">
                  <strong data-id="element-1790">Refunds:</strong> Refunds are provided at our
                  discretion and in accordance with the specific terms of each
                  service.
                </li>
                <li data-id="element-1791">
                  <strong data-id="element-1792">Price Changes:</strong> We reserve the right to change
                  our prices. Any price changes will be communicated to you in
                  advance.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1793">
                7. Intellectual Property
              </h2>
              <p data-id="element-1794">
                All content and IP belong to Creator Boost or its licensors.
                Users retain ownership of their own content but grant us a
                license to use it for service provision.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1795">
                8. Disclaimers & Limitation of Liability
              </h2>
              <p data-id="element-1796">
                Our services are provided "as is" without warranties of any
                kind, either express or implied, including, but not limited to,
                implied warranties of merchantability, fitness for a particular
                purpose, or non-infringement.
              </p>
              <p className="mt-4" data-id="element-1797">
                In no event shall Creator Boost be liable for any indirect,
                incidental, special, consequential, or punitive damages,
                including without limitation, loss of profits, data, use,
                goodwill, or other intangible losses, resulting from your access
                to or use of or inability to access or use the services.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1798">
                9. Indemnification
              </h2>
              <p data-id="element-1799">
                You agree to defend and indemnify Creator Boost against any
                claim arising from your misuse of the services.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1800">
                10. Governing Law & Dispute Resolution
              </h2>
              <p data-id="element-1801">
                These Terms shall be governed by and construed in accordance
                with the laws of the State of Delaware, without regard to its
                conflict of law provisions. Any dispute arising from or relating
                to these Terms shall be subject to the exclusive jurisdiction of
                the courts located within the State of Delaware.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1802">
                11. Termination
              </h2>
              <p data-id="element-1803">
                We reserve the right to suspend or terminate access at our
                discretion or if you violate the Terms.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1804">
                12. Changes to Terms
              </h2>
              <p data-id="element-1805">
                We may update Terms. Continued use after such changes means you
                accept them.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1806">
                13. Contact Us
              </h2>
              <p className="mt-2" data-id="element-1807">
                <strong data-id="element-1808">Email:</strong> gavin.smith@creatorboost.ai
              </p>
              <p data-id="element-1809">
                <strong data-id="element-1810">Address:</strong> 3500 S Dupont Highway, Dover, Delaware
                19901
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1811" />
    </div>;
}